import React from 'react';
import { useNavigate } from "react-router-dom";
import { FUEL_TYPE_ELECTRICITY, FUEL_TYPE_GAS } from '../../config/AppConfigurator';
import { QuerySelection } from '../../components/QuerySelection/QuerySelection';

/* IMPORT STYLES FOR QUERY SELECTION METER ENQUIRY CONTAINER */ 
import './QuerySelectionForMeterEnquiry.scss';

export function QuerySelectionForMeterEnquiry() {
  const navigate  = useNavigate();

  const QuerySelectionFactory = (fuelType) => {
    /* Using Factory Pattern to switch between the containers on the basis of fuel type selected */
      switch(fuelType){
        case FUEL_TYPE_ELECTRICITY:
          navigate('/meter-data-enquiry-method-selection', { state: { fuelType: FUEL_TYPE_ELECTRICITY } });
          break;
        case FUEL_TYPE_GAS:
          navigate('/meter-data-enquiry-method-selection', { state: { fuelType: FUEL_TYPE_GAS } });
          break;
        default:
          navigate('/');
      }
  };

    return (
      <>
        <QuerySelection QuerySelectionFactory={ QuerySelectionFactory } />
      </>
    );
}
